/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES, MenuProps } from "../../utils/constants";
import FormGioiThieu from "./formGioithieu";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };

function GioiThieu() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const setAlert = useSetRecoilState(AlertState);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  //
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [statusState, setStatusState] = useState(ALLVALUE.ma);

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.GIOITHIEU + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      let dataTableNew = [...tableData];
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.GIOITHIEU + "/" + values.id,
          { ...values }
        );
        let rowAdd = response.data;
        dataTableNew[values.rowIndex] = rowAdd;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(API_ROUTES.GIOITHIEU, {
          ...values,
        });
        let rowAdd = response.data;
        dataTableNew.unshift(rowAdd);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData(dataTableNew);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };

  // Lấy toàn bộ dữ liệu
  const fetchData = async (status, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.GIOITHIEU, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(statusState, pagination);
  }, [statusState, pagination]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "tieude",
        header: "Tiêu đề",
        size: 250,
      },
    ],
    []
  );
  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.GIOITHIEU + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa Giới thiệu");
    setValidationErrors({});
    setModalOpen(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 90,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              <Tooltip arrow placement="left" title="Chỉnh sửa">
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Xoá">
                <IconButton
                  color="primary"
                  onClick={() => {
                    let _data = [];
                    _data["id"] = row.getValue("id");
                    _data["tieude"] = row.getValue("tieude");
                    handleOpenDeleteConfirmation(_data);
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ color: "#ffffff" }}
                onClick={() => {
                  setAction("New");
                  setTitle("Thêm mới tin tức");
                  setDataRow({});
                  setValidationErrors({});
                  setModalOpen(true);
                }}
              >
                Tạo mới
              </Button>
            </Stack>
          )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <FormGioiThieu
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tin tức có tiêu đề: {selectedRow?.tieude} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GioiThieu;
